import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NtactLogo from '../assets/NTACT Logo.svg';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import LOgo from '../assets/Ntact.png'
import api from '../api/api';
import { Backdrop, CircularProgress } from '@mui/material';




const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 13,
    fontFamily: 'Helvetica',
    flexDirection: 'column',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  logo: { width: 90, height: 45 },
  title: { fontSize: 18, fontWeight: 'bold', textAlign: 'center' },
  section: { marginBottom: 10 },

  // ==== GRID ====
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  gridItemFull: { 
    border: '1px solid #ccc', 
    padding: 6, 
    width: '100%',
    borderRadius: 4,
    marginBottom: 4,
  },
  gridItemHalf: {
    border: '1px solid #ccc',
    padding: 6,
    width: '48%',
    borderRadius: 4,
    marginBottom: 4,
  },

  // ==== RADIO BUTTONS ====
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    marginTop: 6,
    gap: 8,
  },
  radioButton: {
    width: 13,
    height: 13,
    borderRadius: 7,
    border: '1.5px solid #555',
    marginLeft: 3,
  },
  radioButtonSelectedS: { backgroundColor: '#28a745' },
  radioButtonSelectedC: { backgroundColor: '#dc3545' },
  radioText: { fontSize: 11, marginLeft: 2, marginRight: 4 },

  // ==== CHECKLIST ====
  checklist: { 
    marginBottom: 10, 
    border: '1px solid #ccc', 
    padding: 10, 
    backgroundColor: '#fff',
    borderRadius: 4,
  },
  checklistItem: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    paddingVertical: 3, 
    borderBottom: '0.5px solid #ddd',
  },
  checklistText: { fontSize: 9, textTransform: 'uppercase', flex: 1 },
  
  // ==== CRITICAL FACTORS GRID ====
  criticalGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 10,
    gap: 10,
  },
  criticalBox: {
    width: '48%',
    border: '1px solid #ccc',
    borderRadius: 4,
    padding: 8,
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  criticalTitle: {
    textAlign: 'center',
    backgroundColor: '#f0f0f0',
    paddingVertical: 4,
    marginBottom: 5,
    fontWeight: 'bold',
    fontSize: 11,
    borderBottom: '1px solid #ccc',
  },

  // ==== OTHER ====
  note: { border: '1px solid #ccc', padding: 10, marginBottom: 10, marginTop: 6, borderRadius: 4 },
  comments: { border: '1px solid #ccc', padding: 10, marginBottom: 20, marginTop: 10, borderRadius: 4 },
  underline: { borderBottomWidth: 1, borderBottomColor: '#ccc', marginVertical: 4 },
});

const PDFDocument = ({
  observerName,
  clientobservationsign,
  filledDate,
  empName,
  empId,
  jobDescription,
  jobId,
  taskPerformed,
  stopWorkAuthority,
  feedback,
  ppeItems,
  bodyPositionItems,
  workEnvironmentItems,
  workProcedureItems
}) => (
  <Document>
    {/* ===== PAGE 1: HEADER & INFO ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.header}>
        <Image src={LOgo} style={styles.logo} />
        <Text style={styles.title}>HEALTH SAFETY & ENVIRONMENTAL</Text>
        <View style={{ width: 80 }} />
      </View>

      <View style={styles.grid}>
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold' }}>Document Name:</Text>
          <Text>BBS SAFETY OBSERVATION FORM</Text>
        </View>
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold' }}>Section:</Text>
          <Text>HSE-7</Text>
        </View>
      </View>

      <View style={styles.grid}>
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold' }}>Revision: 1</Text>
        </View>
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold' }}>Date: {filledDate}</Text>
        </View>
      </View>

      <View style={styles.underline} />

      <View style={[styles.section, { textAlign: 'center', borderBottom: '1px solid #000', paddingBottom: 5 }]}>
        <Text style={{ fontSize: 16, fontWeight: 'bold' }}>BEHAVIOR BASED SAFETY (BBS) CARD</Text>
      </View>

      <View style={styles.grid}>
        {observerName && (
          <View style={styles.gridItemHalf}>
            <Text style={{ fontWeight: 'bold' }}>Observer Name:</Text>
            <Text>{observerName}</Text>
          </View>
        )}
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold' }}>Date:</Text>
          <Text>{filledDate}</Text>
        </View>
        {empName && empName !== "N/A" && (
          <View style={styles.gridItemHalf}>
            <Text style={{ fontWeight: 'bold' }}>Employee:</Text>
            <Text>{empName} ({empId})</Text>
          </View>
        )}
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold' }}>Job:</Text>
          <Text>{jobDescription} #{jobId}</Text>
        </View>
      </View>

      <View style={styles.grid}>
        <View style={styles.gridItemHalf}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Stop Work Authority (SWA) Used?</Text>
          <View style={styles.radioContainer}>
            <Text style={styles.radioText}>YES</Text>
            <View style={[styles.radioButton, stopWorkAuthority === 'YES' && styles.radioButtonSelectedS]} />
            <Text style={styles.radioText}>NO</Text>
            <View style={[styles.radioButton, stopWorkAuthority === 'NO' && styles.radioButtonSelectedC]} />
          </View>
        </View>
        <View style={[styles.gridItemHalf, { alignItems: 'center', justifyContent: 'center' }]}>
          {clientobservationsign?.base64_data && (
            <Image src={clientobservationsign.base64_data} style={{ width: 160, height: 40, border: '1px solid #ccc', borderRadius: 4, objectFit: 'contain' }} />
          )}
          <Text style={{ fontWeight: 'bold', marginTop: 6 }}>Client Joint Observation Signature</Text>
        </View>
      </View>

      <View style={styles.gridItemFull}>
        <Text style={{ fontWeight: 'bold' }}>What task(s) were employee(s) performing?</Text>
        <Text>{taskPerformed}</Text>
      </View>

      <View style={styles.note}>
        <Text style={{ fontWeight: 'bold', marginBottom: 5 }}>BBS INSTRUCTIONS:</Text>
        <Text style={{ fontSize: 12 }}>1) Inform co-worker(s) that you are performing a BBS observation.</Text>
        <Text style={{ fontSize: 12 }}>2) Observe task while paying attention to Critical Factors.</Text>
        <Text style={{ fontSize: 12 }}>3) Provide feedback and forward form to the Safety Department.</Text>
      </View>

    </Page>

    {/* ===== PAGE 2: PPE + Body Position ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={[styles.section, { textAlign: 'center', marginBottom: 12 }]}>
        <Text style={{ fontWeight: 'bold', fontSize: 15 }}>CRITICAL FACTORS — S = SAFE, C = CONCERN</Text>
      </View>
      {[{ title: '1. PPE', items: ppeItems },
        { title: '2. Body Position', items: bodyPositionItems },
      ].map((section, sIndex) => (
        <View key={sIndex} style={{ width: '100%', border: '1px solid #ccc', borderRadius: 4, marginBottom: 24, backgroundColor: '#fff' }} wrap={false}>
          <Text style={{ textAlign: 'center', backgroundColor: '#f0f0f0', paddingVertical: 8, fontWeight: 'bold', fontSize: 14, borderBottom: '1px solid #ccc' }}>{section.title}</Text>
          {section.items.map((item, i) => (
            <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 8, paddingHorizontal: 16, borderBottom: '0.5px solid #ddd', minHeight: 32 }}>
              <Text style={{ fontSize: 13, textTransform: 'uppercase', flex: 1 }}>
                {item.question
                  .replace("PPE ", "")
                  .replace("Body Position - ", "")}
              </Text>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                <Text style={{ fontSize: 12, marginRight: 3 }}>S</Text>
                <View style={[styles.radioButton, item.answer === "S" && styles.radioButtonSelectedS]} />
                <Text style={{ fontSize: 12, marginRight: 3 }}>C</Text>
                <View style={[styles.radioButton, item.answer === "C" && styles.radioButtonSelectedC]} />
                <Text style={{ fontSize: 12, marginRight: 3 }}>N/A</Text>
                <View style={[styles.radioButton, item.answer !== "S" && item.answer !== "C" && { backgroundColor: "#6b7280" }]} />
              </View>
            </View>
          ))}
        </View>
      ))}
    </Page>

    {/* ===== PAGE 3: Work Environment + Work Procedure + Feedback ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      {[{ title: '3. Work Environment', items: workEnvironmentItems },
        { title: '4. Work Procedure', items: workProcedureItems },
      ].map((section, sIndex) => (
        <View key={sIndex} style={{ width: '100%', border: '1px solid #ccc', borderRadius: 4, marginBottom: 24, backgroundColor: '#fff' }} wrap={false}>
          <Text style={{ textAlign: 'center', backgroundColor: '#f0f0f0', paddingVertical: 8, fontWeight: 'bold', fontSize: 14, borderBottom: '1px solid #ccc' }}>{section.title}</Text>
          {section.items.map((item, i) => (
            <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 8, paddingHorizontal: 16, borderBottom: '0.5px solid #ddd', minHeight: 32 }}>
              <Text style={{ fontSize: 13, textTransform: 'uppercase', flex: 1 }}>
                {item.question
                  .replace("Work Environment - ", "")
                  .replace("Work Procedure - ", "")}
              </Text>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                <Text style={{ fontSize: 12, marginRight: 3 }}>S</Text>
                <View style={[styles.radioButton, item.answer === "S" && styles.radioButtonSelectedS]} />
                <Text style={{ fontSize: 12, marginRight: 3 }}>C</Text>
                <View style={[styles.radioButton, item.answer === "C" && styles.radioButtonSelectedC]} />
                <Text style={{ fontSize: 12, marginRight: 3 }}>N/A</Text>
                <View style={[styles.radioButton, item.answer !== "S" && item.answer !== "C" && { backgroundColor: "#6b7280" }]} />
              </View>
            </View>
          ))}
        </View>
      ))}

    </Page>

    {/* ===== PAGE 4: IMPROVEMENT INPUT & FEEDBACK ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.comments}>
        <Text style={{ fontWeight: 'bold', marginBottom: 8, fontSize: 16 }}>IMPROVEMENT INPUT</Text>
      </View>

      <View style={[styles.comments, { marginTop: 10 }]}>
        <Text style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 6 }}>Observer's Feedback:</Text>
        <Text style={{ fontSize: 13, lineHeight: 1.5 }}>{feedback}</Text>
      </View>
    </Page>
  </Document>
);



const ViewFormModal = ({ setFormView, rowData, formType, onEdit }) => {
  const formItems = rowData?.json_data || [];
   const formRef = useRef(null);
// formItems.imagekey={
//                             "file_name": "download (10)_20251205091809.jpg",
//                             "file_path": "/var/www/hub2.ntactops.com/ntact/public/assets/forms_files/download (10)_20251205091809.jpg"
//                         }
  const [clientobservationsign,setClientobservationsign]=useState(null)
    const [ocrimg,setOcrimg]=useState(null)
    const [loading, setLoading] = useState(false);
  // Extract specific fields for the header and other sections
  console.log(formItems)
  const observerName =rowData?.observer_name
  const filledDate = rowData?.filled_date || "N/A";
  const taskPerformed = formItems.find(item => item.question?.includes("What task(s) were employee(s) performing"))?.answer || "N/A";
  const stopWorkAuthority = formItems.find(item => item.question?.includes("Stop Work Authority"))?.answer || "N/A";
  const clientJointObservation = formItems.find(item => item.question?.includes("Client Joint Observation"))?.answer || "N/A";
  const feedback = formItems.find(item => item.question?.includes("Observer's feedback"))?.answer || "N/A";

  // Filter items into categories based on question prefixes
  const ppeItems = formItems.filter(item => item.question?.startsWith("PPE"));
  const bodyPositionItems = formItems.filter(item => item.question?.startsWith("Body Position"));
  const workEnvironmentItems = formItems.filter(item => item.question?.startsWith("Work Environment"));
  const workProcedureItems = formItems.filter(item => item.question?.startsWith("Work Procedure"));
  const [view,setView]=useState(0)
const fetchClientObservationImage = async () => {
  try {
    console.log("🟢 Fetching Client Observation signature...");

    // Find the relevant form item
    const clientJointObservation =
    formItems.find(item => item.question?.includes("Client Joint Observation"))?.answer || "N/A";

    if (
  !clientJointObservation ||                     // object itself must exist
  typeof clientJointObservation !== "object" ||  // must be an object
  !clientJointObservation.file_name ||           // file_name must exist
  !clientJointObservation.file_path              // file_path must exist
)  {
      console.log("⚠️ No client observation image found.");
      return null;
    }

    const fileName = clientJointObservation?.file_name;
    if (!fileName) {
      console.warn("⚠️ No file_name in client observation data");
      return null;
    }

    // Call API
    const res = await api.get(
      `/v1/documents/view-multiple?filenames=${encodeURIComponent(fileName)}`
    );

    console.log("📬 API Response:", res);

    if (res.status === 200) {
      const imageUrl = res.data?.images?.[0] || res.images?.[0] || null;
      if (imageUrl) {
        console.log("🖼️ Client Observation Image URL:", imageUrl);
        setClientobservationsign(imageUrl)
        return imageUrl;
      } else {
        console.warn("⚠️ No image URL found in response.");
        return null;
      }
    } else {
      console.warn("⚠️ Non-200 API status:", res.status);
      return null;
    }
  } catch (error) {
    console.error("❌ Error fetching Client Observation image:", error);
    return null;
  }
};
const fetchOcrImage = async (fileName) => {
  try {
setLoading(true)
    // Call API
    const res = await api.get(
      `/v1/documents/view-multiple?filenames=${encodeURIComponent(fileName)}`
    );


    if (res.status === 200) {
      const imageUrl = res.data?.images?.[0] || res.images?.[0] || null;
      if (imageUrl) {
        console.log("🖼️ Client Observation Image URL:", imageUrl);
        setOcrimg(imageUrl)
        return imageUrl;
      } else {
        console.warn("⚠️ No image URL found in response.");
        return null;
      }
    } else {
      console.warn("⚠️ Non-200 API status:", res.status);
      return null;
    }
  } catch (error) {
    console.error("❌ Error fetching Client Observation image:", error);
    return null;
  }finally{
    setLoading(false)
  }
};
useEffect(() => {
    const getClientObservation = async () => {
      setLoading(true);
      fetchClientObservationImage()
    
      setLoading(false);
    };

    getClientObservation();
  }, [formItems]);

  const generatePDF = async () => {
    try {
      const { pdf } = await import('@react-pdf/renderer');
      const blob = await pdf(
        <PDFDocument
          observerName={observerName}
          filledDate={filledDate}
          empName={rowData?.emp_name || "N/A"}
          empId={rowData?.emp_id || "N/A"}
          jobDescription={rowData?.jobDescription || "N/A"}
          jobId={rowData?.job_id || "N/A"}
          taskPerformed={taskPerformed}
          stopWorkAuthority={stopWorkAuthority}
          clientJointObservation={clientJointObservation}
          feedback={feedback}
          ppeItems={ppeItems}
          bodyPositionItems={bodyPositionItems}
          workEnvironmentItems={workEnvironmentItems}
          workProcedureItems={workProcedureItems}
          clientobservationsign={clientobservationsign}
        />
      ).toBlob();
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };


   useEffect(() => {
      if (formRef.current) {
        formRef.current.scrollTop = 0;
      }
    }, []);
  
    const handleBackdropClick = (e) => {
      // Check if the click target is the backdrop itself (not the modal content)
      if (e.target === e.currentTarget) {
        setFormView(false);
      }
    };

  return (
    <div onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40  ">
      <div className="relative w-full max-w-4xl flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
    <div className="w-full flex justify-between items-end">
  <div className="flex gap-4">

    {/* PRINT BUTTON OR PLACEHOLDER */}
    {view === 0 ? (
      <button
        onClick={generatePDF}
        className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
      >
        Print
      </button>
    ) : (
     <></>
    )}

    {/* EDIT BUTTON — only rendered when the parent passes `onEdit`. Hidden on
        the secondary OCR-image view so it doesn't compete with the back
        button. */}
    {view === 0 && typeof onEdit === "function" && (
      <button
        onClick={onEdit}
        className="bg-[#1E4976] text-white px-4 py-1 rounded hover:bg-[#163659]"
      >
        Edit
      </button>
    )}

    {/* UPLOADED IMAGE BUTTON */}
    {/* {formItems?.some(item => item?.capture_form_image?.file_name) && (
      <button
        onClick={() => {
          if (view === 0) {
            const fileName =
              formItems.find(item => item?.capture_form_image?.file_name)
                ?.capture_form_image?.file_name;

            if (fileName) fetchOcrImage(fileName);
          }

          setView(view === 0 ? 1 : 0);
        }}
        className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
      >
        {view === 1 ? "Back To Form" : "View Uploaded Image"}
      </button>
    )} */}
  </div>

  <button onClick={() => setFormView(false)} className="text-gray-600 hover:text-black">
    <CloseIcon />
  </button>
</div>


    
        {view==0?<div ref={formRef} className="w-[90%] mx-auto  overflow-y-auto custom-scrollbar p-4">
          <div className="border-b border-gray-300 pb-2 mb-4">
            <div className='flex w-full justify-between'>
              <img src={NtactLogo} alt='$/'/>
            <div>
                <h2 className="text-lg font-semibold">HEALTH SAFETY & ENVIRONMENTAL</h2>
              </div>
              <div className='mr-24'>

              </div>
            </div>
            <div className="flex justify-between items-center">
              <div>
              <p className="text-sm font-semibold text-left mt-2">Document Name:<br>
              </br> BBS SAFETY OBSERVATION FORM</p>
          
              </div>
              <div className="text-right ">
              
                <p className="text-sm font-semibold text-left">Section: <br>
                </br>HSE-7</p>
          
              </div>
              <div className="text-right">
              
                <p className="text-sm font-semibold">Revision: 1</p>
                <p className="text-sm font-semibold">Date: {filledDate}</p>
             
                <p className="text-sm font-semibold">Document Number: 7-5-A</p>

              </div>
            </div>
          </div>

          {/* Modal Header */}
          <div className="flex items-center justify-center w-full border-b border-gray-300 pb-2 mb-4">
            <h2 className="text-lg font-bold">BEHAVIOR BASED SAFETY (BBS) CARD</h2>
          
          </div>

          {/* Observer and Date Info */}
          <div className="grid grid-cols-2 gap-4 mb-4">
            {observerName?<div className=' border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Observer Name:</p>
              <p className="text-left font-inter p-1 px-2 ">{observerName}</p>
              <hr className="border-t border-[#9CA3AF]" />
              </div>:<></>}
            <div className=' border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Date:</p>
              <p className="text-left font-inter p-1 px-2 ">{filledDate}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            {rowData?.emp_name?<div className=' border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Employee:</p>
              <p className="text-left font-inter p-1 px-2 ">{rowData?.emp_name} ({rowData?.emp_id})</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>:<></>}
            <div className=' border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Job:</p>
              <p className="text-left font-inter p-1 px-2">{rowData?.job_description} #{rowData?.job_id}</p>
              <hr className="border-t border-[#9CA3AF]" />

            </div>
          </div>

          {/* Stop Work Authority and Client Joint Observation */}
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className=' border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Stop Work Authority (SWA) Used?</p>
              <div className="flex space-x-4 mt-1">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="swa"
                    value="YES"
                    checked={stopWorkAuthority === "YES"}
                  
                    className="mr-1 accent-green-600"
                  />
                  YES
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="swa"
                    value="NO"
                    checked={stopWorkAuthority === "NO"}
                  
                    className="mr-1 accent-red-600"
                  />
                  NO
                </label>
              </div>
            </div>
            <div className=' border border-[#9CA3AF] p-1'>
              <p className="text-sm font-inter font-semibold text-left">Client Joint Observation Signature:</p>
              {/* <p className="text-left font-inter p-1 px-2">{clientJointObservation}</p> */}
          
      <div className="mt-4">
       
        <div className="flex flex-wrap gap-4">

            <div
     
              className=" border border-gray-300 rounded overflow-hidden"
            >
              <img
              //  onClick={() => {
              //   setSelectedImage(img)
              // setIsModalOpen(true)
              // }}
                src={clientobservationsign?.base64_data}
                alt={`Signature `}
              style={{
    width: '160px',      // wider
    height: '40px',      // shorter
    border: '1px solid #ccc',
    borderRadius: '4px',
    objectFit: 'contain',
  }}
              />
            </div>
     
        </div>
      </div>
  
              <hr className="border-t border-[#9CA3AF]" />

            </div>
          </div>

          {/* Task Performed */}
          <div  className=' border border-[#9CA3AF] p-1 mb-4'>
            <p className="text-sm font-inter font-semibold text-left">What task(s) were employee(s) performing during the BBS observation?</p>
            <p className="text-sm  text-gray-700 text-left font-inter mt-4 py-2 px-3">{taskPerformed}</p>
            <hr className="border-t border-[#9CA3AF]" />

          </div>

          {/* BBS Instructions */}
          <div className="mb-4 p-4 border border-gray-300 rounded">
            <p className="text-sm font-inter font-semibold text-left mb-2">BBS INSTRUCTIONS:</p>
            <p className="text-sm font-inter text-left">1) Inform co-worker(s) that you are going to perform a BBS observation on the task they are performing.</p>
            <p className="text-sm font-inter text-left">2) Observe co-worker(s) performing task while paying attention to the Critical Factors Section.</p>
            <p className="text-sm font-inter text-left">3) After the observations provide feedback to co-worker(s) whether safe or concerning, some categories may not apply and are to be left blank. Promptly, after observations give this form to your supervisor who will review it and who must then forward it to the Safety Department.</p>
          </div>

          {/* Feedback */}
        

          {/* Critical Factors Header */}
          <div className="mb-4 w-full flex justify-center  p-2">
  <p className="text-sm font-inter text-center font-bold">
    CRITICAL FACTORS S=SAFE C=CONCERN
  </p>
</div>


          {/* Critical Factors Sections */}
          <div className="grid grid-cols-2 gap-4 pr-2">
            {/* PPE */}
            <div className='border'>
              <p className="text-sm font-inter font-semibold text-center border-b pb-1 mb-2 bg-gray-200 p-2">1. PPE</p>
       {ppeItems.map((item, index) => {
  const ans = item.answer;
  const isS = ans === "S";
  const isC = ans === "C";
  const isNA = !isS && !isC; // anything else or empty

  return (
    <div key={index} className="flex justify-between items-center px-2 border-b">
      <p className="text-sm font-inter text-left">
        {item.question.replace("PPE ", "")}
      </p>

      <div className="flex space-x-3">
        {/* S */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`ppe-${index}`}
            value="S"
            checked={isS}
            readOnly
            className={`mr-1 ${isS ? "accent-green-600" : ""}`}
          />
          <span className={isS ? "text-green-600 font-bold" : "text-gray-400"}>S</span>
        </label>

        {/* C */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`ppe-${index}`}
            value="C"
            checked={isC}
            readOnly
            className={`mr-1 ${isC ? "accent-red-600" : ""}`}
          />
          <span className={isC ? "text-red-600 font-bold" : "text-gray-400"}>C</span>
        </label>

        {/* N/A */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`ppe-${index}`}
            value="NA"
            checked={isNA}
            readOnly
            className={`mr-1 ${isNA ? "accent-gray-500" : ""}`}
          />
          <span className={isNA ? "text-gray-600 font-bold" : "text-gray-400"}>
            N/A
          </span>
        </label>
      </div>
    </div>
  );
})}
            </div>

            {/* Body Position */}
            <div className='border'>
              <p className="text-sm font-inter font-semibold text-center border-b pb-1 mb-2 bg-gray-200 p-2">2. Body Position</p>
          {bodyPositionItems.map((item, index) => {
  const ans = item.answer;
  const isS = ans === "S";
  const isC = ans === "C";
  const isNA = !isS && !isC;

  return (
    <div key={index} className="flex justify-between items-center px-2 border-b my-3">
      <p className="text-sm font-inter text-left">
        {item.question.replace("Body Position - ", "")}
      </p>

      <div className="flex space-x-3">
        {/* S */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`body-position-${index}`}
            value="S"
            checked={isS}
            readOnly
            className={`mr-1 ${isS ? "accent-green-600" : ""}`}
          />
          <span className={isS ? "text-green-600 font-bold" : "text-gray-400"}>S</span>
        </label>

        {/* C */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`body-position-${index}`}
            value="C"
            checked={isC}
            readOnly
            className={`mr-1 ${isC ? "accent-red-600" : ""}`}
          />
          <span className={isC ? "text-red-600 font-bold" : "text-gray-400"}>C</span>
        </label>

        {/* N/A */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`body-position-${index}`}
            value="NA"
            checked={isNA}
            readOnly
            className={`mr-1 ${isNA ? "accent-gray-500" : ""}`}
          />
          <span className={isNA ? "text-gray-600 font-bold" : "text-gray-400"}>
            N/A
          </span>
        </label>
      </div>
    </div>
  );
})}
            </div>

            {/* Work Environment */}
            <div className='border'>
              <p className="text-sm font-inter font-semibold text-center bg-gray-200 p-2 border-b pb-1 mb-2">3. Work Environment</p>
            {workEnvironmentItems.map((item, index) => {
  const ans = item.answer;
  const isS = ans === "S";
  const isC = ans === "C";
  const isNA = !isS && !isC;

  return (
    <div key={index} className="flex justify-between items-center px-2 border-b my-3">
      <p className="text-sm font-inter text-left">
        {item.question.replace("Work Environment - ", "")}
      </p>

      <div className="flex space-x-3">
        {/* S */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`work-env-${index}`}
            value="S"
            checked={isS}
            readOnly
            className={`mr-1 ${isS ? "accent-green-600" : ""}`}
          />
          <span className={isS ? "text-green-600 font-bold" : "text-gray-400"}>S</span>
        </label>

        {/* C */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`work-env-${index}`}
            value="C"
            checked={isC}
            readOnly
            className={`mr-1 ${isC ? "accent-red-600" : ""}`}
          />
          <span className={isC ? "text-red-600 font-bold" : "text-gray-400"}>C</span>
        </label>

        {/* N/A */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`work-env-${index}`}
            value="NA"
            checked={isNA}
            readOnly
            className={`mr-1 ${isNA ? "accent-gray-500" : ""}`}
          />
          <span className={isNA ? "text-gray-600 font-bold" : "text-gray-400"}>
            N/A
          </span>
        </label>
      </div>
    </div>
  );
})}
            </div>

            {/* Work Procedure */}
            <div className='border'>
              <p className="text-sm font-inter font-semibold bg-gray-200 p-2 text-center border-b pb-1 mb-2">4. Work Procedure</p>
            {workProcedureItems.map((item, index) => {
  const ans = item.answer;
  const isS = ans === "S";
  const isC = ans === "C";
  const isNA = !isS && !isC;

  return (
    <div key={index} className="flex justify-between items-center px-2 border-b my-3">
      <p className="text-sm font-inter text-left">
        {item.question.replace("Work Procedure - ", "")}
      </p>

      <div className="flex space-x-3">
        {/* S */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`work-procedure-${index}`}
            value="S"
            checked={isS}
            readOnly
            className={`mr-1 ${isS ? "accent-green-600" : ""}`}
          />
          <span className={isS ? "text-green-600 font-bold" : "text-gray-400"}>S</span>
        </label>

        {/* C */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`work-procedure-${index}`}
            value="C"
            checked={isC}
            readOnly
            className={`mr-1 ${isC ? "accent-red-600" : ""}`}
          />
          <span className={isC ? "text-red-600 font-bold" : "text-gray-400"}>C</span>
        </label>

        {/* N/A */}
        <label className="flex items-center">
          <input
            type="radio"
            name={`work-procedure-${index}`}
            value="NA"
            checked={isNA}
            readOnly
            className={`mr-1 ${isNA ? "accent-gray-500" : ""}`}
          />
          <span className={isNA ? "text-gray-600 font-bold" : "text-gray-400"}>
            N/A
          </span>
        </label>
      </div>
    </div>
  );
})}
            </div>
          </div>
          <div className="mb-4">
            <div className='text-[16px] my-4 text-left font-semibold'>IMPROVEMENT INPUT</div>
            <div className=' border border-[#9CA3AF] p-1'>
            <p className="text-sm font-inter font-semibold text-left">Observer's Feedback (Action Taken or Recommendation):</p>
            <p className="text-sm text-wrap text-gray-700 text-left font-inter py-2 px-3">{feedback}</p>
            <hr className="border-t border-[#9CA3AF]" />

            </div>

          </div>
        </div>:<>
        
        <div className="w-[90%] mx-auto  overflow-y-auto custom-scrollbar p-4">

  {ocrimg?.base64_data&& (
  <img
    src={ocrimg?.base64_data}
    alt="Captured Image"
    className="rounded"
    style={{ maxWidth: "100%", height: "auto" }}
    
  />
)}

        </div>
      

</>}
      </div>
              <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default ViewFormModal;